<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent">
            <div class="printOrderListBox">
                <div class="orderListTable">
                    <el-table
                        :data="goodsList"
                        border
                        ref="table"
                        @sort-change="sortChange"
                        style="width: 100%" class="tableContent">
                        <el-table-column
                            prop="materialName"
                            label="材料名称"
                            header-align="center"
                            show-overflow-tooltip
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="orderCount"
                            label="订单数"
                            sortable
                            header-align="center"
                            show-overflow-tooltip
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="orderPrice"
                            label="支付金额"
                            sortable
                            header-align="center"
                            show-overflow-tooltip
                            align="center">
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        background
                        @current-change="handleCurrentChange"
                        @prev-click="handleCurrentChange"
                        @next-click="handleCurrentChange"
                        layout="total,prev, pager, next,jumper"
                        :current-page="current"
                        :page-size="pageSize"
                        :total="total" class="pagination">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { queryMaterialList } from '../../utils/interface'
    export default {
        name: "materialManagerInfo",
        computed: {},
        data() {
            return {
                name:"",
                goodsList:[],
                current:1,
                pageSize:10,
                total:0,
                startDate:null,
                endDate:null,
                orderBy:"",
            };
        },
        methods: {
            init(startDate,endDate,name) {
                this.$refs.table.clearSort();
                this.orderBy = "";
                this.name = name;
                this.startDate = startDate;
                this.endDate = endDate;
                this.getManagerList();
            },
            getManagerList(){
                let params = {
                    name:this.name,
                    startDate:this.startDate,
                    endDate:this.endDate,
                    current:this.current,
                    pageSize:this.pageSize,
                    orderBy:this.orderBy
                };
                queryMaterialList(params).then((res)=>{
                    this.current = res.current;
                    this.total = res.total;
                    this.goodsList = res.list;
                });
            },
            // 分页
            handleCurrentChange(val){
                this.current = val;
                this.getManagerList();
            },
            sortChange(column){
                if(column&&column.order!=null) {
                    if(this.orderBy===""){
                        this.orderBy = column.prop + "_ascend";
                    }else if(this.orderBy.indexOf("ascend")>-1){
                        this.orderBy = column.prop + "_descend";
                    }else if(this.orderBy.indexOf("descend")>-1){
                        this.orderBy = column.prop + "_ascend";
                    }
                    this.current = 1;
                    this.getManagerList();
                }
            },
        },
    };
</script>
<style scoped lang="less">
    .pagination {
        margin-top: 20px;
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/views/statistic/materialManagerInfo.vue